<template>
    <v-card outlined >
        <v-alert v-if="!customer" type="error" tile border-bottom>CUSTOMER IS DEACTIVATED</v-alert>
        <v-card-actions  v-if="customer">
            <div class="title">{{name.name}}</div>
            <v-spacer></v-spacer>
            <div class="title">Contract: {{customer.contract.contract_type.desc}}</div>
            <v-spacer></v-spacer>
            <div class="title">ENV: {{customer.environment.environment_type.desc}}</div>
            <v-spacer></v-spacer>
        </v-card-actions>
        <v-divider class="mr-2 ml-2"></v-divider>
        <v-card-text class="pa-1" v-if="customer">
            <v-item-group>
                <v-row justify="space-around">
                    <v-col transition="scale-transition" v-for="group in toggleGroups" :cols="group.active ? '12' : false" :key="group.title" :order="group.active ? group.display_by_clicked : group.display_order">
                        <v-card outlined tile>
                            <v-card-text  class="pa-0">
                                <v-card class="text-center title text-capitalize" @click="activateItem(group)" flat tile>{{group.title}}</v-card>
                            </v-card-text>
                            <v-card-text class="pa-0" v-if="group.active">
                                <component :is="group.title" :customer_id="customer_id"></component>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

            </v-item-group>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "CustomerInfo",
        components:{
            Addresses: () => import("./Addresses"),
            Contacts: () => import("./Contacts"),
            Contract: () => import("./Contract"),
            Environment: () => import("./Environment"),
            Imperatives: () => import('./Imperatives'),
            Licenses: () => import('./Licenses'),
            Names: () => import('./Names'),
            Notes: () => import('./Notes')
        },
        props: {
            customer_id: {
                required: true,
            }
        },
        data: () => ({
            toggleGroups: [
                {title: 'Addresses', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Contacts', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Contract', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Environment', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Imperatives', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Licenses', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Names', active: false, display_order: 12, display_by_clicked: 12},
                {title: 'Notes', active: false, display_order: 12, display_by_clicked: 12},
            ]
        }),
        computed:{
            name(){
                return this.$store.$db().model('names').query().where('customer_id', this.customer_id).where('name_type_id', 1).first();
            },
            customer(){
                return this.$store.$db().model('customers').query().with(['contract.contract_type', 'environment.environment_type']).find(this.customer_id)
            },
        },
        watch:{
            customer_id(){
               this.toggleGroups.forEach(item => {
                   item.active = false;
                   item.display_by_clicked = 12;
               } )
            }
        },
        methods:{
            activateItem(item){
                item.display_by_clicked = this.toggleGroups.filter(item => item.active).length;
                item.active = !item.active;
            }
        }
    }
</script>

<style scoped>

</style>
